import z from "zod";

const xactanalysisErrorTypeValues = [
  "UNKNOWN",
  "ORGANIZATION_NOT_SUPPORTED",
  "ASSIGNMENT_CLAIM_AND_CARRIER_IDS_NOT_FOUND",
  "FAILED_TO_GET_XA_TOKEN",
  "NO_SUMMARY_FOUND_IN_XACTDOC",
  "ERROR_CREATING_RFQ_EVENT_DATA",
  "COULD_NOT_FIND_XML_ATTACHMENT_URL",
  "CARRIER_ID_NOT_SUPPORTED",
  "CARRIER_ID_NOT_HANDLED",
  "ASSIGNMENT_NOT_LEGACY_HANDLED",
  "UNSUPPORTED_PDF_FORMAT",
  "INVALID_COMPOSITE_ID",
  "NO_COVERAGES_FOUND_IN_ESTIMATE_XML",
] as const;
const xactanalysisErrorTypeSchema = z.enum(xactanalysisErrorTypeValues);
export const XactanalysisErrorType = xactanalysisErrorTypeSchema.enum;
export type XactanalysisErrorType = z.infer<typeof xactanalysisErrorTypeSchema>;

export type XactanalysisErrors =
  | { errorType: typeof XactanalysisErrorType.UNKNOWN; data: undefined }
  | { errorType: typeof XactanalysisErrorType.ORGANIZATION_NOT_SUPPORTED; data: { organizationId: string } }
  | {
      errorType: typeof XactanalysisErrorType.ASSIGNMENT_CLAIM_AND_CARRIER_IDS_NOT_FOUND;
      data: { assignmentId: string; claimNumber: string; carrierId: string };
    }
  | {
      errorType: typeof XactanalysisErrorType.FAILED_TO_GET_XA_TOKEN;
      data: undefined;
    }
  | {
      errorType: typeof XactanalysisErrorType.NO_SUMMARY_FOUND_IN_XACTDOC;
      data: { assignmentId: string; carrierId: string; claimNumber: string };
    }
  | {
      errorType: typeof XactanalysisErrorType.ERROR_CREATING_RFQ_EVENT_DATA;
      data: { errors: string[] };
    }
  | {
      errorType: typeof XactanalysisErrorType.COULD_NOT_FIND_XML_ATTACHMENT_URL;
      data: { attachments: string[] };
    }
  | {
      errorType: typeof XactanalysisErrorType.CARRIER_ID_NOT_SUPPORTED;
      data: { carrierId: string; compositeId: string | undefined };
    }
  | {
      errorType: typeof XactanalysisErrorType.CARRIER_ID_NOT_HANDLED;
      data: { carrierId: string; assignmentId: string; claimNumber: string };
    }
  | {
      errorType: typeof XactanalysisErrorType.ASSIGNMENT_NOT_LEGACY_HANDLED;
      data: { assignmentId: string; webhookEventType: string };
    }
  | { errorType: typeof XactanalysisErrorType.UNSUPPORTED_PDF_FORMAT; data: undefined }
  | { errorType: typeof XactanalysisErrorType.INVALID_COMPOSITE_ID; data: { compositeId: string } }
  | {
      errorType: typeof XactanalysisErrorType.NO_COVERAGES_FOUND_IN_ESTIMATE_XML;
      data: { coverageCount: number; inScopeCount: number };
    };

export const xactanalysisErrorDetails: Record<XactanalysisErrorType, { sentryDescription: string }> = {
  UNKNOWN: { sentryDescription: "Unknown Xactanalysis Error" },
  ORGANIZATION_NOT_SUPPORTED: { sentryDescription: "Organization not supported" },
  ASSIGNMENT_CLAIM_AND_CARRIER_IDS_NOT_FOUND: { sentryDescription: "Assignment claim and carrier ids not found" },
  FAILED_TO_GET_XA_TOKEN: { sentryDescription: "Failed to get XA token" },
  NO_SUMMARY_FOUND_IN_XACTDOC: { sentryDescription: "No summary found in xactDoc" },
  ERROR_CREATING_RFQ_EVENT_DATA: { sentryDescription: "Error creating RFQ event data" },
  COULD_NOT_FIND_XML_ATTACHMENT_URL: { sentryDescription: "Could not find XML attachment url" },
  CARRIER_ID_NOT_SUPPORTED: { sentryDescription: "Carrier id not supported" },
  CARRIER_ID_NOT_HANDLED: { sentryDescription: "Carrier id is not handled by any XA pipeline (legacy or partner)" },
  ASSIGNMENT_NOT_LEGACY_HANDLED: {
    sentryDescription: "Assignment is not handled by the legacy XA flow (no BidRequest found)",
  },
  UNSUPPORTED_PDF_FORMAT: { sentryDescription: "Unsupported Xactimate PDF format" },
  INVALID_COMPOSITE_ID: { sentryDescription: "Unexpected senderExternalUniqueId compositeId format" },
  NO_COVERAGES_FOUND_IN_ESTIMATE_XML: {
    sentryDescription:
      "Estimate XML had no in-scope coverage with financial totals; refusing to ingest all-zero estimate",
  },
};
